var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgIgu(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.18 4.74A9.715 9.715 0 0010 .277a9.679 9.679 0 00-5.944 2.027l3.089.312A7.904 7.904 0 0110 2.085a7.881 7.881 0 015.446 2.17l3.267 1.42a9.567 9.567 0 00-.532-.934zm1.441 3.838l-1.706 1.485a7.916 7.916 0 01-15.831-.022L.366 8.67c-.06.434-.09.879-.09 1.33 0 5.37 4.353 9.724 9.724 9.724 5.37 0 9.724-4.354 9.724-9.724 0-.483-.034-.958-.103-1.422z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.016 8.033c.109-.04.216-.074.32-.105.865-.26 1.585-.295 1.954-.354a1.514 1.514 0 00-.111-.085c-.764-.53-2.077-.468-3.277-.161a6.713 6.713 0 01-.723-.605c.085-.045.171-.088.256-.129 1.819-.874 3.554-.704 4.132-.874a3.17 3.17 0 00-.256-.156c-1.438-.8-3.608-.684-5.234-.125-.239-.255-.53-.482-1-.693.125-.056.25-.106.373-.151.981-.361 1.885-.418 2.458-.5a2.377 2.377 0 00-.417-.25c-1.578-.74-3.644.396-5.349.058C4.581 3.39 1.478 3.66.737 5.817c-.11.347-.124.612.28.89 2.115 1.758 4.973 3.95 6.009 5.988a2.48 2.48 0 00-.237-.161 3.651 3.651 0 00-.875-.371c.03.053.057.107.085.163.738 1.504.968 4.087 3.246 3.584l.03-.006c-.391-1.766-.922-3.325-.78-4.557 0-.004 0-.009.002-.014.049-.414.176-.79.41-1.125.055-.063.113-.117.174-.164l.006-.005c.425-.328.96-.334 1.274-.52l.002-.001c.335-.2.414-.606-.168-1.835.105.105.201.21.287.318.771.965.68 1.995-.824 2.307-1.035.23-.403 2.366.584 6.935v-.037c-.03-3.362 1.019-4.47 2.945-4.261 1.934.208 3.716-1.318 3.244-3.677a25.768 25.768 0 01-2.415-1.235zm-9.445-2.66c-.517-.136-.732-.597-.83-.872.716-.24 1.365-.13 1.392-.113.023.015.493.303.74.447-.352.431-.715.696-1.302.538z",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 0.275,
    y1: 10,
    x2: 19.724,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AED3"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0D4"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 0.67,
    y1: 10.416,
    x2: 16.567,
    y2: 10.416,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AED3"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0D4"
  })))));
}
export default SvgIgu;